import ContentContainer from "./ContentContainer"
import ContentText from "./ContentText"

const Content = {
  Container: ContentContainer,
  Text: ContentText
}

export { Content, ContentContainer, ContentText }
